import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { Fade, Typography, Button, Box } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { AlertDialog } from 'components'

import useCookieBanner from 'hooks/useCookieBanner'
import useStyles from './styles'

import constants from 'constants/index'

const CompilationAlerts = ({ onCustomAction }) => {
  const [openDialog, setOpenDialog] = useState(false)
  const [openScannerDialog, setOpenScannerDialog] = useState(false)

  const {
    ageGate,
    banner,
    isAgeGateCompiling,
    isCompiling,
    isScanning,
    activeStep,
    setActiveStep,
    refreshBanner,
    refreshAgeGate,
  } = useCookieBanner()

  const classes = useStyles()
  const { ALERTS, STEPS, FAILED_SCANNER_STATUS_ID } = constants.cookies.banner
  const { FAILED_BUILD_STATUS_ID } = constants.cookies.build

  const alertConditions = [
    {
      condition: () => banner?.build?.status === FAILED_BUILD_STATUS_ID,
      alert: ALERTS.BUILD_FAILED,
    },
    {
      condition: () => ageGate?.build?.status === FAILED_BUILD_STATUS_ID,
      alert: ALERTS.AGE_GATE_BUILD_FAILED,
    },
    {
      condition: () => isAgeGateCompiling,
      alert: ALERTS.AGE_GATE_COMPILATION,
    },
    {
      condition: () => activeStep === STEPS.CONFIGURATION,
      alert: ALERTS.CONFIGURATION,
    },
    {
      condition: () => activeStep === STEPS.CUSTOMIZATION,
      alert: ALERTS.CACHE,
    },
    {
      condition: () => activeStep === STEPS.SCANNER,
      alert: ALERTS.AUTOSCANNER,
    },
    {
      condition: () => activeStep === STEPS.CLASSIFICATION,
      alert: ALERTS.CLASSIFICATION,
    },
    {
      condition: () => activeStep === STEPS.INSTALLATION,
      alert: ALERTS.AUTOCOMPILATION,
    },
    {
      condition: () => activeStep === STEPS.COOKIE_POLICY,
      alert: ALERTS.COOKIE_POLICY,
    },
    {
      condition: () => activeStep === STEPS.AGE_GATE,
      alert: ALERTS.AGE_GATE,
    },
    {
      condition: () => isCompiling,
      alert: ALERTS.COMPILATION,
    },
    {
      condition: () => isScanning,
      alert: ALERTS.SCANNER,
    },
    {
      condition: () => banner?.scanner?.status === FAILED_SCANNER_STATUS_ID,
      alert: ALERTS.SCANNER_FAILED,
    },
  ]

  const activeAlerts = alertConditions
    .filter(({ condition }) => condition())
    .map(({ alert }) => alert)

  const handleAlertAction = (alert) => {
    const { key, refreshAction, actionType, actionStep } = alert

    if (refreshAction) {
      if (key === ALERTS.AGE_GATE_COMPILATION.key) return refreshAgeGate()
      return refreshBanner()
    }
    if (actionType && onCustomAction) return onCustomAction(actionType)
    if (actionStep !== undefined) return setActiveStep(actionStep)
  }

  useEffect(() => {
    if (isCompiling) setOpenDialog(true)
    if (isScanning) setOpenScannerDialog(true)
  }, [isCompiling, isScanning])

  if (isEmpty(activeAlerts)) return null

  return (
    <>
      <Box className={classes.alertsContainer}>
        {activeAlerts.map((alert) => {
          const { key, severity, title, message, actionLabel } = alert

          return (
            <Fade in key={key}>
              <Alert
                variant="outlined"
                severity={severity}
                action={
                  actionLabel && (
                    <Button
                      size="small"
                      variant="contained"
                      color="secondary"
                      onClick={() => handleAlertAction(alert)}
                    >
                      {actionLabel}
                    </Button>
                  )
                }
              >
                <Typography>
                  {title && <strong>{title}</strong>} {message}
                </Typography>
              </Alert>
            </Fade>
          )
        })}
      </Box>

      {isCompiling && (
        <AlertDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          variant="outlined"
          severity="warning"
          content="O seu banner está sendo compilado, este processo pode levar até 5 minutos. Por favor, aguarde alguns instantes e atualize a página se necessário. Obrigado pela compreensão!"
        />
      )}

      {isScanning && (
        <AlertDialog
          open={openScannerDialog}
          onClose={() => setOpenScannerDialog(false)}
          variant="outlined"
          severity="warning"
          content="O seu site está sendo escaneado, este processo pode levar até 5 minutos. Por favor, aguarde alguns instantes e atualize a página se necessário. Obrigado pela compreensão!"
        />
      )}
    </>
  )
}

CompilationAlerts.propTypes = {
  onCustomAction: PropTypes.func,
}

export default CompilationAlerts
